import React from 'react';
import { useLocation } from 'react-router-dom';
import GAService from '../../services/GAService';

const Analytics = () => {
  const { pathname, search } = useLocation();

  React.useEffect(() => {
    GAService.recordPageView(pathname + search);
  }, [pathname, search]);

  return null;
};

export default Analytics;
